// @ts-nocheck
import type { DataRef, ItemMetricKey } from '../../types/binding';
import type { ExpressionAstNode } from '../expressions/types';

export function collectItemMetricRefsFromDataRef(ref: DataRef): ItemMetricKey[] {
  const out = new Set<ItemMetricKey>();
  collectFromDataRef(ref, out);
  return [...out];
}

function collectFromDataRef(ref: DataRef, out: Set<ItemMetricKey>): void {
  if (ref.kind === 'itemMetric') {
    out.add(ref.metric);
  }
}

export function collectItemMetricRefsFromValueSource(source: unknown): ItemMetricKey[] {
  const out = new Set<ItemMetricKey>();
  if (!source || typeof source !== 'object') {
    return [];
  }
  const vs = source as Record<string, unknown>;
  if (vs.kind === 'binding' && vs.ref != null && typeof vs.ref === 'object') {
    collectFromDataRef(vs.ref as DataRef, out);
  } else if (vs.kind === 'expression' && vs.root != null && typeof vs.root === 'object') {
    walkAst(vs.root as Record<string, unknown>, out);
  }
  return [...out];
}

function walkAst(node: Record<string, unknown> | null | undefined, out: Set<ItemMetricKey>): void {
  if (!node || typeof node !== 'object') {
    return;
  }
  const kind = node.kind;
  if (kind === 'ref') {
    const ref = node.ref as DataRef | undefined;
    if (ref) {
      collectFromDataRef(ref, out);
    }
    return;
  }
  if (kind === 'literal') {
    return;
  }
  if (kind === 'unary') {
    walkAst(node.arg as Record<string, unknown>, out);
    return;
  }
  if (kind === 'binary') {
    walkAst(node.left as Record<string, unknown>, out);
    walkAst(node.right as Record<string, unknown>, out);
    return;
  }
  if (kind === 'if') {
    walkAst(node.when as Record<string, unknown>, out);
    walkAst(node.then as Record<string, unknown>, out);
    walkAst(node.else as Record<string, unknown>, out);
    return;
  }
  if (kind === 'callPure') {
    const args = node.args as unknown[] | undefined;
    if (Array.isArray(args)) {
      for (const arg of args) {
        if (arg && typeof arg === 'object') {
          walkAst(arg as Record<string, unknown>, out);
        }
      }
    }
  }
}

export function collectItemMetricRefsFromAstRoot(root: Record<string, unknown> | null | undefined): ItemMetricKey[] {
  const out = new Set<ItemMetricKey>();
  walkAst(root, out);
  return [...out];
}

export function collectItemMetricRefsFromExpressionRoots(
  roots: Array<Record<string, unknown> | null | undefined>,
): ItemMetricKey[] {
  const out = new Set<ItemMetricKey>();
  for (const root of roots) {
    walkAst(root, out);
  }
  return [...out];
}

/** @deprecated Use collectItemMetricRefsFromAstRoot */
export function collectItemMetricRefs(ast: ExpressionAstNode | Record<string, unknown>): ItemMetricKey[] {
  return collectItemMetricRefsFromAstRoot(ast as Record<string, unknown>);
}
